




























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class Container extends Vue {
  @Prop() multiBG!: boolean;
  
  @Prop() bgColour!: string;
}
